//angular
import { ActivatedRoute, Router } from '@angular/router';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
//app
import { slideInRightAnimation, smoothAppearance } from 'src/app/_shared/animations';
import { CompanyNotification } from 'src/app/_shared/models/notifications.model';
import { DialogConfirmationComponent } from 'src/app/modules/main/_shared/dialog/confirmation/confirmation.component';
import { DialogNewNotificationsComponent } from '../new-notifications/dialog-new-notifications/dialog-new-notifications.component';
import { NotificationSectionValues, CompanyNotificationChannelStatus, NotificationChannels, CompanyNotificationChannelType, responseCode } from 'src/app/app.data';
import { KeyName } from 'src/app/app.keynames';
import { RestResponse } from 'src/app/_shared/models';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoaderService } from 'src/app/_core/services';
import { SettingsService } from '../../../_services/api/settings.service';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';
import {
  RebNgxIconsRegistry,
  RebNgxIconChevronDown,
} from '@rhinosaas/reb-ngx/reb-ngx-icon';
import { SendTestDialogComponent } from './send-test-dialog/send-test-dialog.component';

@Component({
  animations: [smoothAppearance, slideInRightAnimation],
  selector: 'app-manage-notifications',
  templateUrl: './manage-notifications.component.html'
})

export class ManageNotificationsComponent implements OnInit, OnDestroy {
  collectionOfNotifications: Array<CompanyNotification> = [];
  dialogNewNotifications: MatDialogRef<DialogNewNotificationsComponent>;
  dialogConfirmation: MatDialogRef<DialogConfirmationComponent>;
  isNotificationsByKeyNameReady: boolean = false;
  labelNotificationSection: string;
  notificationSectionKeyName: NotificationSectionValues;
  channelKeyName: string;
  private subs = new Unsubscriber();
  headerTitle: string = '';

  @Input() _notificationSectionValues = NotificationSectionValues;
  @Input() _companyNotificationChannelStatus = CompanyNotificationChannelStatus;
  @Input() _companyNotificationChannelType = CompanyNotificationChannelType;

  constructor(
    private _dialog: MatDialog,
    private _iconRegistry: MatIconRegistry,
    private _loader: LoaderService,
    public _meta: MetaService,
    private rebNgxIconsRegistry: RebNgxIconsRegistry,
    private _sanitizer: DomSanitizer,
    private settingsService: SettingsService,
    private _route: ActivatedRoute,
    private _router: Router,
  ) {
    this._iconRegistry.addSvgIcon('ico-actions', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-actions-01.svg'));
    this._iconRegistry.addSvgIcon('ico-back', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-back-03.svg'));
    this._iconRegistry.addSvgIcon('ico-delete', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-delete-02.svg'));
    this._iconRegistry.addSvgIcon('ico-edit', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-edit-02.svg'));
    this._iconRegistry.addSvgIcon('ico-preview', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-preview-01.svg'));
    this._iconRegistry.addSvgIcon('ico-email', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-mail-02.svg'));


    this.subs.addSub = this._route.params.subscribe(params => {
      this.notificationSectionKeyName = params['notificationSectionKeyName'];
    });
  }

  getHeaderTitle() {
    switch (this.notificationSectionKeyName) {
      case this._notificationSectionValues.customerOnBoardingEmails:
        this.headerTitle = 'Onboarding Emails';
        break;
      case this._notificationSectionValues.customNotifications:
        this.headerTitle = 'Custom Notifications';
        break;
      case this._notificationSectionValues.dunningForOfflinePayments:
        this.headerTitle = 'Dunning For Off-Line Payments';
        break;
      case this._notificationSectionValues.dunningForOnlinePayments:
        this.headerTitle = 'Dunning For On-Line Payments';
        break;
      case this._notificationSectionValues.futureSubscriptionReminders:
        this.headerTitle = 'Future Subscription Reminders';
        break;
      case this._notificationSectionValues.invalidPaymentMethods:
        this.headerTitle = 'Invalid Payment Methods';
        break;
      case this._notificationSectionValues.invoiceReceipt:
        this.headerTitle = 'Invoice Receipt';
        break;
      case this._notificationSectionValues.onBoardingEmails:
        this.headerTitle = 'Subscription Statuses';
        break;
      case this._notificationSectionValues.onBoardingNotifications:
        this.headerTitle = 'On Boarding Notifications';
        break;
      case this._notificationSectionValues.paymentCollect:
        this.headerTitle = 'Payment Collect';
        break;
      case this._notificationSectionValues.paymentMethod:
        this.headerTitle = 'Payment Methods';
        break;
      case this._notificationSectionValues.paymentsAndCredits:
        this.headerTitle = 'Payments And Credits';
        break;
      case this._notificationSectionValues.selfServePortalAccountManagement:
        this.headerTitle = 'Self Serve Portal Account Management';
        break;
      case this._notificationSectionValues.standardNotifications:
        this.headerTitle = 'Standard Notifications';
        break;
      case this._notificationSectionValues.subscriptionActivation:
        this.headerTitle = 'Subscription Activation';
        break;
      case this._notificationSectionValues.subscriptionCancellations:
        this.headerTitle = 'Subscription Cancellations';
        break;
      case this._notificationSectionValues.subscriptionChanges:
        this.headerTitle = 'Subscription Updates';
        break;
      case this._notificationSectionValues.subscriptionRenewalReminders:
        this.headerTitle = 'Subscription Reminders';
        break;
      case this._notificationSectionValues.automaticProcess:
        this.headerTitle = 'Runtime tasks';
        break;
    }
  }

  createChannelNotification(_bodyParams: any, notificationData?: any) {
    if(notificationData){
      const payload = {
        // "oldChannelId": notificationData.channel?.id,
        "companyNotificationTemplateId": notificationData.channel.companyNotificationTemplate.id,
        "oldCompanyIntegrationId": notificationData.channel?.companyIntegration.id,
        ..._bodyParams
      }

      this.subs.addSub = this.settingsService.editChannelNotification(notificationData.notification?.id, payload).subscribe(
        (res)=>this.handleSuccessAfterSaveEdit(res), (err)=>this.handleErrorAfterSave(err)
      );
    } else {
      this.subs.addSub = this.settingsService.createChannelNotification(_bodyParams).subscribe(
        (res)=>this.handleSuccessAfterSave(res), (err)=>this.handleErrorAfterSave(err)
      );
    }
  }
  handleSuccessAfterSaveEdit(res){
    this.getNotificationsByKeyName(this.notificationSectionKeyName);
    this._meta.showNotification(res);
    this._loader.stopPageLoader();
  }
  handleSuccessAfterSave(res){
    // TODO: no deberia devolver el notification channel nuevo?
    const companyNotificationChannel = res.data.companyNotificationChannels.find(channel => channel.keyName === this.channelKeyName),
    keyName = companyNotificationChannel?.keyName,
    templateId = companyNotificationChannel?.companyNotificationTemplate.id;

    this._loader.stopPageLoader();
    this._meta.showNotification(res);
    // redirects to corresponding template page
    if(keyName)
      this.redirectTo(keyName, templateId);
  }

  handleErrorAfterSave(err){
    this._loader.stopPageLoader();
    this._meta.showNotification(err);
  }

  getNotificationsByKeyName(_notificationSectionKeyName: string) {
    this.subs.addSub = this.settingsService.getNotificationByKeyName(_notificationSectionKeyName).subscribe(
      (res: RestResponse) => {
        this.collectionOfNotifications = [];
        this.collectionOfNotifications = <Array<CompanyNotification>>res.data;
        this.isNotificationsByKeyNameReady = true;
      },
      (err: RestResponse) => {
        this.isNotificationsByKeyNameReady = true;
        this._meta.showNotification(err);
      }
    );
  }

  ngOnInit() {
    this.rebNgxIconsRegistry.registerIcons([RebNgxIconChevronDown]);
    this.getHeaderTitle();
    this.getNotificationsByKeyName(this.notificationSectionKeyName);
  }

  deleteChannelNotification(_notificationId: number, _channelId: number) {
    this._loader.startPageLoader();
    this.subs.addSub = this.settingsService.deleteChannelNotificationByChannelId(_notificationId, _channelId).subscribe(
      (res: RestResponse) => {
        this._loader.stopPageLoader();
        this._meta.showNotification(res);

        this.getNotificationsByKeyName(this.notificationSectionKeyName);
      },
      (err: RestResponse) => {
        this._loader.stopPageLoader();
        this._meta.showNotification(err);
      }
    );
  }

  showDialogConfirmationForDeleteChannelNotification(_notificationId, _channel) {
    this.dialogConfirmation = this._dialog.open(DialogConfirmationComponent, {
      panelClass: 'custom-mat-dialog',
      data: {
        keyName: KeyName.delete_notification,
        notificationChannel: _channel,
        word_confirmation: 'DELETE NOTIFICATION'
      }
    });

    this.dialogConfirmation.afterClosed().subscribe((res) => {
      if (res == KeyName.delete_notification) {
        this.deleteChannelNotification(_notificationId, _channel.id);
      }
    });
  }

  redirectTo(_notificationChannelKeyName: string, _templateId: number) {
    if (_notificationChannelKeyName === NotificationChannels.customerGoogle || _notificationChannelKeyName === NotificationChannels.merchantEmail || _notificationChannelKeyName === NotificationChannels.customerSmtp || _notificationChannelKeyName === NotificationChannels.merchantSmtp) {
      this._router.navigate([`main/settings/advanced/notifications/${this.notificationSectionKeyName}/templates/${_templateId}`]);
    } else if (_notificationChannelKeyName === NotificationChannels.companyNotificationInbox) {
      this._router.navigate([`main/settings/advanced/notifications/${this.notificationSectionKeyName}/inboxes/${_templateId}`]);
    }
  }

  showDialogNewNotifications(notificationData?: any) {
    this.dialogNewNotifications = this._dialog.open(DialogNewNotificationsComponent, {
      panelClass: ['custom-mat-dialog', 'mat-dialog-shipping-settings'],
      data: {
        notificationSectionKeyName: this.notificationSectionKeyName,
        notificationData
      }
    });
    this.dialogNewNotifications.afterClosed().subscribe((res) => {
      if (res?.code === KeyName.request_success) {
        this.channelKeyName = res.data.channel.keyName;
        this.createChannelNotification(res.data.bodyParams, notificationData);
      }
      if (res?.code === KeyName.request_error) {
        this._loader.stopPageLoader();
        this._meta.showNotificationCustomMessage(responseCode.errorBadRequestCode, KeyName.error_form_attributes);
      }
    });
  }

  updateNotificationChannelStatus(notificationId: number, channelId: number, currentStatus) {
    const bodyParams = {
      status: currentStatus === CompanyNotificationChannelStatus.active ? CompanyNotificationChannelStatus.disabled : CompanyNotificationChannelStatus.active
    }
    this.subs.addSub = this.settingsService.updateNotificationByChannelId(notificationId, channelId, bodyParams).subscribe(
      (res: RestResponse) => {
        this._meta.showNotification(res);
      },
      (err: RestResponse) => {
        this._meta.showNotification(err);
      }
    );
  }

  sendTest(notificationId: number, channelId: number, currentStatus): void {
    const bodyParams = {
      email: 'string'
    };
    const dialogRef = this._dialog.open(SendTestDialogComponent, {
      width: '300px'
    })

    dialogRef.afterClosed().subscribe((email) => {
      if (email) {
        this.subs.addSub = this.settingsService.sendNotificationByChannelId(notificationId, channelId, {email}).subscribe(
          (res: RestResponse) => {
            this._meta.showNotification(res);
          },
          (err: RestResponse) => {
            this._meta.showNotification(err);
          }
        );
      }
    })
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

